import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import moment from "jalali-moment";
import DoneIcon from "@mui/icons-material/Done";

// import JS files
import MuiDatePicker from "../../shares/MuiDatePicker";
import OrderCard from "../../shares/OrderCard";
import { Checkbox } from "@mui/material";

const AdminOrderCard = ({
  children,
  DontshowEditIconForAdmin,
  item,
  showAcceptBtn,
  showResetAcceptBtn,
  update_ring_item,
  reset_update_ring_item,
  edit_ring_item,
  move_date_to_parent,
  editable_component,
  dateDisabled = false,
  DontShowDatePicker,
  baseFromRing,
  adminNeedDifference,
  showCheckBox,
  ChantgeBoxState,
  CheckBoxState,
  showRemainTotal,
  dontShowStoreName,
  ShowOrderCode,
}) => {
  const [editable, setEditable] = useState(item.is_active);

  const [dateValue, setDateValue] = useState(
    moment(item.receive_at).format("YYYY-MM-DD")
  );

  function dateOnChange(date) {
    setDateValue(date);
    if (!dateDisabled) {
      move_date_to_parent(date);
    }
  }

  const handle_switch_change = (event) => {
    edit_ring_item(item.id, item.is_active);
    editable_component(!editable, item.id);
    setEditable(!editable);
  };

  return (
    <>
      <div
        className="border rounded-lg p-2 mt-2"
        style={{ backgroundColor: "#fefcfb" }}
      >
        <OrderCard
          showTotal
          showRemainTotal={showRemainTotal}
          ShowOrderCode={ShowOrderCode}
          dontShowStoreName={dontShowStoreName}
          item={item}
          baseFromRing={baseFromRing}
          adminNeedDifference={adminNeedDifference}
          have5Col
        >
          <div className=" md:grid grid-cols-12 gap-x-2 items-center">
            <div className="md:col-span-1">
              {DontshowEditIconForAdmin ? (
                ""
              ) : (
                <>
                  <div className="flex items-center">
                    <span className="text-xs md:text-sm">ویرایش:</span>
                    <Switch
                      onChange={handle_switch_change}
                      checked={!editable}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="md:col-span-8">{children}</div>
            <div className="col-span-3 grid grid-cols-4">
              {DontShowDatePicker ? (
                <></>
              ) : (
                <div className="col-span-2 mt-2 md:-mt-1">
                  <MuiDatePicker
                    onChange={dateOnChange}
                    value={dateValue}
                    disabled={editable | dateDisabled ? true : false}
                  />
                </div>
              )}

              {showCheckBox ? (
                <>
                  <div className="ol-span-1 text-left md:text-center">
                    <Checkbox
                      onChange={() => ChantgeBoxState(item.id)}
                      checked={CheckBoxState.includes(item.id)}
                    />
                  </div>
                </>
              ) : null}

              {showAcceptBtn && (
                <div
                  className="accept-icon col-span-1 text-left md:text-center mt-4 md:mt-1"
                  disabled={
                    DontshowEditIconForAdmin ? false : editable ? true : false
                  }
                  onClick={() => update_ring_item(item.id)}
                >
                  <DoneIcon />
                </div>
              )}
              {showResetAcceptBtn && (
                <div
                  className="reset-icon col-span-1 text-left md:text-center mt-4 md:mt-1"
                  disabled={
                    DontshowEditIconForAdmin ? false : editable ? true : false
                  }
                  onClick={() => reset_update_ring_item(item.id)}
                >
                  <DoneIcon />
                </div>
              )}
            </div>
          </div>
        </OrderCard>
      </div>
    </>
  );
};

export default AdminOrderCard;
